module.exports = __webpack_public_path__ + "assets/img/success.d5cafd36.png";